export const origin = () => window.location.origin;
export const href = () => window.location.href;
export const pathname = () => window.location.pathname;
export const openNewWindow = url => url && window.open(url, '_blank');
